/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import { decodeJWT, AuthTokenDecoder, Email } from "src/utils";

export class OktaAuthTokenDecoder implements AuthTokenDecoder {
  extractEmail(token: string): Email {
    return decodeJWT<OktaDecodedIdToken>(token)?.payload.email ?? null;
  }
}

type OktaDecodedIdToken = {
  sub: string;
  name: string;
  email: string;
  ver: number;
  iss: string;
  aud: string;
  iat: number;
  exp: number;
  jti: string;
  amr: Array<string>;
  idp: string;
  nonce: string;
  preferred_username: string;
  auth_time: number;
  at_hash: string;
};

export const oktaAuthTokenDecoder = new OktaAuthTokenDecoder();
